







	import { Component, Vue } from 'vue-property-decorator';
	import { SearchType } from '../Scripts/ISearchService';

@Component
	export default class SearchSummary extends Vue {
		get count (): number {
			return this.$store.state.result.count;
		}

		// same code appears in grid view
		get entityName (): string {
			switch (this.$store.state.result.searchType) {
			case SearchType.Course: return 'Course';
			case SearchType.Program: return 'Program';
			default: return 'Unknown Type';
			}
		}
	}
